import { createContext } from 'react';

const legalesContext = createContext();

export default legalesContext;